import { render, staticRenderFns } from "./SliderGalleryComponent.vue?vue&type=template&id=30de6649&scoped=true&"
import script from "./SliderGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./SliderGalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./SliderGalleryComponent.vue?vue&type=style&index=0&id=30de6649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de6649",
  null
  
)

export default component.exports